import { Reveal } from "@/components/Reveal";
import { CountUp } from "@/components/CountUp";
import { LiquidPageHeader } from "@/components/liquid/LiquidPageHeader";
import { ZoomParallax } from "@/components/liquid/ZoomParallax";
import { VelocityMarquee } from "@/components/liquid/VelocityMarquee";
import { VideoBackdrop } from "@/components/liquid/VideoBackdrop";
import { ParallaxY } from "@/components/liquid/ParallaxY";
import { pageVideo } from "@/lib/videos";
import { CHAPTERS } from "@/lib/content";
import { useContent } from "@/context/ContentContext";
import { useBooking } from "@/context/BookingContext";

const IMG_INTERIOR =
  "/api/files/royal-skin-clinic/uploads/740bc530-c42a-41cd-908c-117d767ec0c2.webp";
const IMG_PRODUCTS =
  "/api/files/royal-skin-clinic/uploads/2949c3fa-6b1e-4ba3-962b-af63a9d59bf0.webp";

export default function AboutLiquid() {
  const { content } = useContent();
  const { book } = useBooking();
  const s = content?.settings || {};

  const stats = [
    { value: s.stat_years || "10+", label: "Years of Excellence" },
    { value: s.stat_patients || "10,000+", label: "Glowing Patients" },
    { value: s.stat_satisfaction || "99.4%", label: "Satisfaction Rate" },
    { value: "24/7", label: "Concierge Support" },
  ];

  return (
    <div className="relative z-[1] px-4 pb-24 pt-36 sm:px-8 sm:pt-44 lg:px-16" data-testid="about-liquid">
      <VideoBackdrop src={pageVideo(s, "about")} testid="about-video-bg" />
      <div className="mx-auto max-w-6xl">
        <LiquidPageHeader
          index="03"
          eyebrow="Our Story"
          title="A Sanctuary for Skin"
          subtitle="Royal Skin Cosmetic Clinic was founded on a simple belief: world-class dermatology should feel like a retreat, not a procedure."
          testid="about-title"
        />

        <div className="mt-16 grid items-start gap-12 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Reveal>
              <ParallaxY speed={0.5}>
                <ZoomParallax src={IMG_INTERIOR} alt="Inside the Royal Skin clinic" className="h-[55vh] rounded-[4px] shadow-[0_40px_90px_rgba(26,26,26,0.15)]" />
              </ParallaxY>
            </Reveal>
            <Reveal delay={0.15}>
              <ParallaxY speed={-0.8}>
                <div className="mt-4 ml-auto w-2/3">
                  <ZoomParallax src={IMG_PRODUCTS} alt="Medical-grade skincare" className="h-56 rounded-[4px]" />
                </div>
              </ParallaxY>
            </Reveal>
          </div>
          <div className="lg:col-span-7 lg:pt-10">
            {CHAPTERS.map((c, i) => (
              <Reveal key={c.n} delay={i * 0.1}>
                <div className="border-b border-[#1A1A1A]/10 py-8 first:pt-0" data-testid={`about-${c.n.toLowerCase().replace(" ", "-")}`}>
                  <p className="text-[11px] font-medium uppercase tracking-[0.35em] text-[#B38B2D]">{c.n}</p>
                  <h3 className="mt-3 font-display text-3xl font-normal text-[#1A1A1A] sm:text-4xl">{c.title}</h3>
                  <p className="mt-4 max-w-xl text-base font-light leading-relaxed text-[#5A504B]">{c.text}</p>
                </div>
              </Reveal>
            ))}
            <Reveal delay={0.3}>
              <button onClick={() => book()} data-testid="about-book-button" className="btn-gold mt-8 px-8 py-4 text-sm">
                Experience It Yourself
              </button>
            </Reveal>
          </div>
        </div>
      </div>

      <div className="mt-20">
        <VelocityMarquee items={["Dubai Healthcare City", "Physician-Led", "Medical-Grade", "Quiet Luxury"]} />
      </div>

      <Reveal className="mx-auto mt-20 max-w-6xl">
        <div className="grid gap-px overflow-hidden rounded-[4px] bg-[#1A1A1A]/10 sm:grid-cols-2 lg:grid-cols-4" data-testid="about-stats-band">
          {stats.map((st) => (
            <div key={st.label} className="bg-[#FAF8F5] p-10 text-center">
              <CountUp value={st.value} className="block font-display text-5xl font-normal text-[#B38B2D]" />
              <p className="mt-2 text-[10px] uppercase tracking-[0.25em] text-[#1A1A1A]/45">{st.label}</p>
            </div>
          ))}
        </div>
      </Reveal>
    </div>
  );
}
